import catalog from '../data/panamaLocations4.json';
export const normalizeLocationSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
const clean = value => String(value || '').replace(/\s*\(general\)\s*$/i,'').trim();
const entries = new Map();
for (const province of catalog) for (const district of province.districts || []) for (const corregimiento of district.corregimientos || []) {
  const names = [clean(corregimiento.name), ...(corregimiento.zones || []).map(clean)];
  for (const zone of names) {
    const fields={province:province.province,district:clean(district.name),corregimiento:clean(corregimiento.name),zone};
    const id=Object.values(fields).map(normalizeLocationSearch).join('|');
    if(!zone || entries.has(id))continue;
    const aliases=[...(province.aliases || []),...(district.aliases || []),...(corregimiento.aliases || [])];
    entries.set(id,{id,...fields,label:[...new Set(Object.values(fields))].join(', '),search:normalizeLocationSearch([...Object.values(fields),...aliases].join(' '))});
  }
}
export const panamaLocationOptions = [...entries.values()];
export function searchPanamaLocations(query,limit=6) {
  const normalized=normalizeLocationSearch(query);
  if(!normalized)return panamaLocationOptions.slice(0,limit);
  const terms=normalized.split(' ');
  const rank=option=>{const zone=normalizeLocationSearch(option.zone);const corregimiento=normalizeLocationSearch(option.corregimiento);return zone===normalized?0:corregimiento===normalized?1:zone.startsWith(normalized)?2:zone.includes(normalized)?3:4;};
  return panamaLocationOptions.filter(option=>terms.every(term=>option.search.includes(term))).sort((a,b)=>rank(a)-rank(b)||a.label.localeCompare(b.label,'es')).slice(0,limit);
}
